<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';

    import { cn } from '$lib/utils/cn';

    import Box from '../_wrappers/Box.svelte';

    import type { DividerSize } from '$lib/types/Components/Divider/DividerContent';
    import type { Box as BoxType } from '$lib/types/Components/SharedTypes';
    import type { TransitionEffect } from '$lib/types/Theme';

    export let box: BoxType;
    export let hidden = false;
    export let dashed = false;
    export let color = '#d4d4d8';
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'default';
    export let layout = DEFAULT_LAYOUT;
    export let size: DividerSize = 'small';

    // Default font-family to Sans Serif as some custom fonts break the page when having special chars as content
    const dividerClasses = cn('fun-select-none fun-border-t fun-font-sans', {
        'fun-border-dashed': dashed,
        '!fun-border-transparent': hidden,
    });

    const sizeToPaddingClassMap: Record<DividerSize, string> = {
        small: 'fun-py-5',
        medium: 'fun-py-8',
        large: 'fun-py-11',
        xLarge: 'fun-py-16',
    };

    const dividerBox = layout.isInColumn ? { ...box, left: 'none', right: 'none' } : box;
</script>

<Box {...dividerBox} {transitionDelay} {transitionEffect}>
    <div class={cn('fun-h-0 fun-select-none', sizeToPaddingClassMap[size])}>
        <div style="border-color: {color};" class={dividerClasses}>&nbsp;</div>
    </div>
</Box>
